import { PATH_HOME } from "@configs";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

export const PageError404 = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <Result
      status="500"
      title="500"
      subTitle="Sorry, something went wrong."
      extra={
        <Button type="primary" onClick={() => history.push(PATH_HOME)}>
          {t("page.back_home")}
        </Button>
      }
    />
  );
};
